import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@mui/material';
import DesktopLayout from './DesktopLayout';
import Leads from '../pages/Leads';

// Desktop two-pane shell for Leads: left list, right preview/conversation
const LeadsDesktopShell = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const location = useLocation();

  // At exactly /leads or /leads/ there is no detail selected
  const hasDetail = !/^\/leads\/?$/.test(location.pathname);

  if (!isDesktop) {
    // Mobile keeps the normal full-page flow
    return hasDetail ? <Outlet /> : <Leads />;
  }

  // Desktop: WhatsApp-like split layout
  return (
    <DesktopLayout
      mode="chats"
      listContent={<Leads />}
      detailContent={hasDetail ? <Outlet /> : null}
    />
  );
};

export default LeadsDesktopShell;
